import { z } from 'zod';

export const uuid = z.uuid();
export const isoDate = z.string().regex(/^\d{4}-\d{2}-\d{2}$/);
export const hhmm = z.string().regex(/^([01]\d|2[0-3]):[0-5]\d$/);
export const timeZone = z.string().min(1).max(64);

export interface ApiErrorBody {
  error: { code: string; message: string };
}
